// extracted by mini-css-extract-plugin
module.exports = {"InternalLinks":"internalLinks_InternalLinks__7k6JF","Title":"internalLinks_Title__nHZ4F","Items":"internalLinks_Items__b7BGN","Item":"internalLinks_Item__1rhNv"};